import React from "react";
import { WordPath } from "../hooks/FindWordPath";
type RenderCodeProps = {
  path: WordPath | null;
  isGameStarted: boolean;
  isGameFinished: boolean;
  tableRows: number;
  tableColumns: number;
  wordIndex: number;
};
const RenderCode: React.FC<RenderCodeProps> = ({
  path,
  isGameStarted,
  isGameFinished,
  tableRows,
  tableColumns,
  wordIndex,
}) => {
  if (!path) {
    return null;
  }
  const getArrow = (current: [number, number], next: [number, number]) => {
    const [row, col] = current;
    const [nextRow, nextCol] = next;

    if (nextCol > col) return "→";
    if (nextCol < col) return "←";
    if (nextRow > row) return "↓";
    if (nextRow < row) return "↑";

    return "";
  };
  const getStartArrow = (row: number, col: number) => {
    if (col === 0) return "→";
    if (col === tableColumns - 1) return "←";
    if (row === 0) return "↓";
    if (row === tableRows - 1) return "↑";

    return "";
  };
  const arrows = path.cells.map((cell, index) => {
    if (index === 0) {
      const [row, col] = cell;

      return getStartArrow(row, col);
    }

    return getArrow(path.cells[index - 1], cell);
  });
  const sizecell = arrows.length < 12 ? "4vw" : "3vw";
  const sizeSmall = arrows.length > 11;
  return (
    <div
      className={`navigatorCode-board-game-code--Type2 ${sizeSmall ? "navigatorCode-code-small--Type2" : ""}`}
      style={{
        gridTemplateColumns: `repeat(${arrows.length+1}, ${sizecell})`,
      }}
    >
      <div
        className={`navigatorCode-board-game-code-cell--Type2 ${sizeSmall ? "navigatorCode-code-cell-small--Type2" : ""} word-search-number--has-number`}
      >
         <span className="navigatorCode-arrow--Type2">
          {isGameStarted && !isGameFinished ? wordIndex+1 : ""}
        </span>
      </div>
      {arrows.map((arrow, index) => (
        <div
          key={index}
          className={`navigatorCode-board-game-code-cell--Type2 ${sizeSmall ? "navigatorCode-code-cell-small--Type2" : ""}`}
        >
          <span className="navigatorCode-arrow--Type2">
            {isGameStarted && !isGameFinished ? arrow : ""}
          </span>
        </div>
      ))}
    </div>
  );
};

export default RenderCode;
